export interface AssistantLinkPolicy {
  hosts: readonly string[];
  allowCurrentOrigin: boolean;
}

export const DEFAULT_ASSISTANT_LINK_POLICY: AssistantLinkPolicy = {
  hosts: ["support.zeffy.com", "zeffy.com", "www.zeffy.com"],
  allowCurrentOrigin: true,
};

const parseUrl = (href: string): URL | null => {
  try {
    return new URL(href);
  } catch {
    return null;
  }
};

export const isAllowedAssistantLink = (
  href: string,
  currentOrigin: string,
  policy: AssistantLinkPolicy = DEFAULT_ASSISTANT_LINK_POLICY
): boolean => {
  const url = parseUrl(href);
  if (!url || url.username || url.password) {
    return false;
  }
  return (
    (url.protocol === "https:" && policy.hosts.includes(url.hostname)) ||
    (policy.allowCurrentOrigin && url.origin === currentOrigin)
  );
};
